import { shared } from '../engine/useStory';
import Scene from '../components/Scene';

export default function StartScene() {
  const { emit } = shared.story;
  return <Scene onClick={() => emit('click_screen')}></Scene>
}
